import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import react from 'react';
import axios from 'axios';
import {host} from '../../function/api'

export const index = createAsyncThunk(
    'documentAgentRequestIndex',
    async(token, thunkApi) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}document/agent/request`,
                headers: {
                    'Accept': 'Application/json',
                    'Authorization': `Bearer ${token}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
        })

            return response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

const initialState= {
    locaidng: false,
    success: false,
    agentRequestList: [],
    message: '',
    error: '',
}

const DocumentAgentRequestSlice = createSlice({
    name: 'documentAgentRequest',
    initialState,
    reducers: {

    },
    extraReducers: {
        [index.fulfilled]: (state, action) => {
            state.agentRequestList = action.payload.data
            state.loading = false
            state.success = true
            state.error = ""
        },
        [index.pending]: (state) => {
            state.loading = true
            state.success = false
        },
        [index.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            if(payload.response.data.error){
                state.error = payload.response.data.error
            }
            if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = DocumentAgentRequestSlice.actions;
export default DocumentAgentRequestSlice.reducer; 